module.exports = __webpack_public_path__ + "img/xingjiabi3.a60d4d38.jpg";